export const THIRD_PARTY_TECH_PARTNER_ACL_OBJECTS = [
    'ThirdPartyTechPartnerNew',
    'ThirdPartyTechPartnerDetail',
    'ThirdPartyTechnologyPartnerList',
];
